
















import { CampaignFormData, NO_LIMIT } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType } from '@vue/composition-api';

const name = 'ttam-age';
export default defineComponent({
  name,
  props: {
    dynamicStyling: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonWidth: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const _age = computed({
      get: () => {
        if (props?.value?.length === 0) {
          const noLimit = [NO_LIMIT];
          emit('input', noLimit);
          emit('change', noLimit);
          return noLimit;
        }
        return props.value;
      },
      set: val => {
        emit('input', val);
      },
    });
    const calculateWidth = computed(() => {
      if (props.buttonWidth) {
        return { width: `${props.buttonWidth}px` };
      }
      return {};
    });
    return {
      _age,
      calculateWidth,
    };
  },
});
